/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.enrichment.applications.rpc.CustomEnrichmentService
 */

export const enrichCompanyRpc = {
  serviceName: 'com.hubspot.enrichment.applications.rpc.CustomEnrichmentService',
  rpcName: 'enrichCompany',
  auth: 'app',
  fingerprint: 'xRQdXBA_sEmIBxf-0oO6_1M77NnR3q8d',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const enrichCompanyBatchRpc = {
  serviceName: 'com.hubspot.enrichment.applications.rpc.CustomEnrichmentService',
  rpcName: 'enrichCompanyBatch',
  auth: 'app',
  fingerprint: 'ndAPI0CfSsUKd2rwkXpsw1M77NnR3q8d',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};